import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CustomValidationService {

  constructor() { }

  compareDates(startDate: string, endDate: string) {
    return (formGroup: FormGroup<any>) => {
      
      const startDateControl = formGroup.controls[startDate];
      const endDateControl = formGroup.controls[endDate];
      if (!startDateControl.value || !endDateControl.value) {
        return null;
      }

      if (endDateControl.errors && !endDateControl.errors.endDateMismatch) {
        return null;
      }
      if (startDateControl.value > endDateControl.value) {
        return endDateControl.setErrors({ endDateMismatch: true });
      } else {
        return endDateControl.setErrors(null);
      }
    }
  }
}
